module.exports = __webpack_public_path__ + "static/media/image.1c496c92.svg";